export default "__VITE_ASSET__Dq_phfBw__"